import { forwardRef, ReactElement, ReactNode, useRef, MutableRefObject } from 'react';
import styled from "styled-components";

type CardProps = {
    children: ReactNode;
    title: string | ReactElement;
    subtitle?: string;
    textColor?: string;
    id?: string;
    [rest: string]: any;
};

export const Card = forwardRef<any, CardProps>(({ children, title, subtitle, textColor = "var(--color-blue)", id, ...rest }, ref) => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <Wrapper {...rest} ref={contentRef}>
      <StickyContainer $textColor={textColor}>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </StickyContainer>
      <ContentContainer
        ref={(node) => {
          contentRef.current = node;
          if (typeof ref === 'function') {
            ref(node);
          }
          else if (ref) {
            (ref as MutableRefObject<any>).current = node;
          }
        }}
        id={id}
      >
        {children}
      </ContentContainer>
    </Wrapper>
  )
});

const Wrapper = styled.div`
    grid-column: 2 / -2;
    min-height: 200px;
    padding: 20px;
    display: contents;
    gap: var(--gap);
`;
const ContentContainer = styled.div`
    grid-column: 2 / -2;
    padding: 1em 0;
    text-align: justify;
    scroll-margin-top: 7em;
`;
interface ITitleContainer {
  $textColor: string;
}
const StickyContainer = styled.div<ITitleContainer>`
    grid-column: 2 / -2;
    position: sticky;
    top: var(--header-height);
    background: linear-gradient(to bottom, var(--color-background) 0%, var(--color-background) 60%, transparent 100%);
    height: 100%;
    z-index: 1;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: baseline;
    gap: var(--gap);
    font-family: var(--heading-font), sans-serif;
    color: ${props => props.$textColor};
    word-wrap: anywhere;
    padding: 1em 0;

    @media (max-width: 820px) {
        display: flex;
        flex-direction: column;
        gap: 0;
        position: initial;
        padding-bottom: 0;
    }
`;
const Title = styled.h2`
    font-size: clamp(1.3rem, -3rem + 9vw, 1rem);
    width: max-content;
    max-width: 100%;
`;
const Subtitle = styled.h3`
    font-size: clamp(0.8rem, -3rem + 9vw, 1rem);
    text-align: right;

    @media (max-width: 820px) {
        text-align: left;
    }
`;